import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { bulkHideUser, getInvitateUsers, hideUser } from "../../api/brokers";
import { Cookies } from "react-cookie";
import { IoMdSend } from "react-icons/io";

const InvitationUserComponent = () => {
  const cookie = new Cookies();
  const [users, setUsers] = useState(null);
  const [hideId, setHideId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [currentPage, setCurrentPage] = useState(cookie.get("inv_page") || 1);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [idsSelected, setIdsSelected] = useState([]);

  const fetchUsers = () => {
    setIdsSelected([]);
    setUsers(null)
    getInvitateUsers(currentPage, searchTerm).then((result) => {
      setUsers(result.data.users);
      setPageCount(result.data.pageCount);
      setTotalCount(result.data.totalCount);
    });
  };

  useEffect(() => {
    setUsers(null);
    fetchUsers();
  }, [currentPage]);

  const hide = (id) => {
    hideUser(id).then((result) => {
      fetchUsers();
      console.log(result);
      setHideId("");
    });
  };

  const bulkHide = () => {
    bulkHideUser(idsSelected).then((result) => {
      fetchUsers();
      setIdsSelected([]);
    });
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("resale_page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      cookie.set("resale_page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const handleSelect = (id) => {
    if (idsSelected.includes(id)) {
      setIdsSelected(idsSelected.filter((item) => item !== id));
    } else {
      setIdsSelected([...idsSelected, id]);
    }
  };
  const handleSelectAll = () => {
    const allIds = users.map((item) => item._id);

    if (idsSelected.length === allIds.length) {
      setIdsSelected([]); // unselect all
    } else {
      setIdsSelected(allIds); // select all
    }
  };

  return (
    <>
      {users === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="search-container">
            <form
              onSubmit={(e) => {
                e.preventDefault(); // Prevent page reload
                handlePageClick(1);
                fetchUsers()
              }}
            >
              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Name or Phone number"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                <button
                  type="submit"
                  className="password-toggle"
                  aria-label="Show password"
                >
                  <IoMdSend />
                </button>
              </div>
            </form>
          </div>

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {renderPageNumbers()}
            <button
              onClick={handleNext}
              disabled={currentPage === pageCount}
              className="paginationButton"
            >
              Next
            </button>
          </div>

          <div>Number of users is {totalCount}</div>

          <div className="card-cards">
            {users?.length === 0 ? (
              <div>Not found brokers</div>
            ) : (
              <>
                {users.length > 0 && (
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <label>
                      <input
                        style={{ marginRight: "10px", marginTop: "10px" }}
                        type="checkbox"
                        checked={idsSelected.length === users.length}
                        onChange={() => {
                          handleSelectAll();
                        }}
                        className="client-checkbox"
                      />
                      Select all users in this page
                    </label>
                    {idsSelected.length > 0 && (
                      <button
                        onClick={() => {
                          bulkHide();
                        }}
                        className="action-btn remove-btn"
                      >
                        Delete {idsSelected.length} invitation
                      </button>
                    )}
                  </div>
                )}
                {users?.map((broker) => (
                  <div
                    key={broker._id}
                    style={{ flexDirection: "row", display: "flex" }}
                  >
                    <input
                      style={{ marginRight: "10px" }}
                      type="checkbox"
                      checked={idsSelected.includes(broker?._id)}
                      onChange={() => {
                        handleSelect(broker._id);
                      }}
                      className="client-checkbox"
                    />
                    <div
                      className={`card-card ${broker.ban ? "banned" : ""}`}
                      style={{ width: "100%" }}
                    >
                      <div className="card-info">
                        <div>
                          <p className="line">
                            <span className="label">Name:</span>{" "}
                            {broker.user_id?.name}
                          </p>
                          <p className="line">
                            <span className="label">phone:</span>{" "}
                            {broker.user_id?.phone}
                          </p>
                          <p className="line">
                            <span className="label">Phone of invited:</span>{" "}
                            {broker.phone}
                          </p>
                          <p className="line">
                            <span className="label">Invited at:</span>{" "}
                            {broker.createdAt.split("T")[0]}
                          </p>
                          {hideId === broker._id && (
                            <div
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <p className="line">
                                Are you sure you want to delete this?{" "}
                              </p>
                              <div className="card-info">
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      setHideId("");
                                    }}
                                    className="action-btn remove-btn"
                                  >
                                    No
                                  </button>
                                </div>
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      hide(broker._id);
                                    }}
                                    className="action-btn accept-btn"
                                  >
                                    Yes
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isSuper && hideId === "" && (
                        <button
                          onClick={() => {
                            setHideId(broker._id);
                          }}
                          className="action-btn remove-btn"
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InvitationUserComponent;
